import mainMenuJson from "@/layout/sticky-column/main-menu/model/main_menu.json";
import type Menu from "@/layout/sticky-column/main-menu/model/Menu";
import { colors } from "@/shared/style/design_system/Colors.ts";

const _COLORS = new Map<string, string[]>([
  ["accueil", [colors.lagoon300, colors.lagoon400]],
  ["people_management", [colors.hr100, colors.hr300, colors.hr400]],
  [
    "materials_management",
    [
      colors.materialManagement100,
      colors.materialManagement200,
      colors.materialManagement300,
    ],
  ],
  ["haccp", [colors.haccp100, colors.haccp200, colors.haccp300]],
  ["documents_home", []],
  [
    "compta",
    [colors.accounting400, colors.accounting500, colors.accounting600],
  ],
  ["analysis", [colors.analysis50, colors.analysis100]],
  ["caisses", [colors.cashRegisterSheet200, colors.cashRegisterSheet300]],
  ["fileexchange", [colors.importExport200, colors.importExport300]],
]);

interface MenuItemColors {
  bg: string;
  hover: string;
}

const _COLORS_MAP = buildColorsTree();

function buildColorsTree(): Map<string, MenuItemColors> {
  const res = new Map<string, MenuItemColors>();
  for (const root of mainMenuJson) {
    for (const level1 of root.children ?? []) {
      const colors = _COLORS.get(root.key);
      if (colors === undefined) continue;
      res.set(level1.key, { bg: colors[0], hover: colors[1] });
      for (const level2 of level1.children) {
        res.set(level2.key, { bg: colors[1], hover: colors[2] });
      }
    }
  }
  return res;
}

export function subMenuColors(menu?: Menu): MenuItemColors {
  const missingRed = {
    bg: "#ee0000",
    hover: "#ff4000",
  };
  return menu === undefined ? missingRed : (
      (_COLORS_MAP.get(menu.key) ?? missingRed)
    );
}
